import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Stack, Box, Text } from '@hub-la/design-system';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Close from '@mui/icons-material/Close';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { usePostUnsubscribeNotification } from '../hooks/use-post-unsubscribe.js';

const UnsubscribeNotification = () => {
  const params = useParams();
  const {
    t
  } = useTranslation();
  const {
    isLoading,
    isError
  } = usePostUnsubscribeNotification({
    token: params.token
  });
  if (isLoading) {
    return jsx(Stack, Object.assign({
      justifyContent: "center",
      textAlign: "center",
      maxWidth: 650,
      mx: "auto"
    }, {
      children: jsx(Box, {
        children: jsx(CircularProgress, {
          size: 64
        })
      })
    }));
  }
  if (isError) {
    return jsxs(Stack, Object.assign({
      justifyContent: "center",
      textAlign: "center",
      maxWidth: 650,
      mx: "auto"
    }, {
      children: [jsx(Box, {
        children: jsx(Close, {
          sx: {
            width: 64,
            height: 64
          },
          color: "error"
        })
      }), jsx(Text, Object.assign({
        variant: "h2",
        mb: 2,
        mt: 3
      }, {
        children: t('unsubscribeNotification.error.title')
      })), jsx(Text, {
        children: t('unsubscribeNotification.error.description')
      })]
    }));
  }
  return jsxs(Stack, Object.assign({
    justifyContent: "center",
    textAlign: "center",
    maxWidth: 650,
    mx: "auto"
  }, {
    children: [jsx(Box, {
      children: jsx(CheckCircleIcon, {
        sx: {
          width: 64,
          height: 64
        },
        color: "success"
      })
    }), jsx(Text, Object.assign({
      variant: "h2",
      mb: 2,
      mt: 3
    }, {
      children: t('unsubscribeNotification.success.title')
    })), jsx(Text, {
      children: t('unsubscribeNotification.success.description')
    })]
  }));
};

export { UnsubscribeNotification };
